var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getAddressServiceQualification from './getAddressServiceQualification';
import AppState from '../AppState';
/**
 * Clears address selections and resets the display of elements on the page.
 *
 * @param {HTMLElement} results - The element that displays the address results.
 * @param {HTMLInputElement} addressField - The input field used for
 *                                          entering the address.
 * @param {HTMLElement} clearSearch - The element that triggers the clearing of
 *                                    the search.
 * @param {HTMLElement} addressConfirmation - The element that displays the
 *                                            confirmed address.
 * @param {HTMLElement} buttonGroupConfirm - The element that contains buttons
 *                                           for confirming the selection.
 *
 * @returns {void}
 */
const clearSelections = (results, addressField, clearSearch, addressConfirmation, buttonGroupConfirm) => {
    addressField.value = '';
    clearSearch.style.display = 'none';
    results.classList.remove('active');
    addressConfirmation.style.display = 'none';
    results.style.display = 'block';
    buttonGroupConfirm.style.display = 'none';
    removeResultItems(results);
};
/**
 * Removes search result items from the DOM.
 *
 * @param {HTMLElement} items - The parent element containing search result items.
 */
const removeResultItems = (items) => {
    const searchResults = Array.from(items.querySelectorAll('#address-search-results li.search-result'));
    searchResults.forEach(result => result.remove());
};
/**
 * API call to get address search results on keystroke.
 *
 * @param {KeyboardEvent} event - The keyboard event triggered by the user.
 * @returns {void}
 */
export const getAddressSuggestion = (event) => {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { context, settings } = drupalJsObjects;
    const { vocusApiRootAddressSuggest, onePlatformApiRoot, onePlatformApiClientId, onePlatformApiClientSecret } = settings;
    const addressEndpoint = onePlatformApiRoot + vocusApiRootAddressSuggest + '?partialText=';
    const addressResults = context.querySelector('#address-search-results');
    const addressField = context.querySelector('#edit-search-query');
    const buttonGroupConfirm = context.querySelector('#button-group-confirm');
    const addressConfirmation = context.querySelector('#address-confirmation');
    const addressConfirmed = context.querySelector('#address-confirmed');
    const clearSearch = context.querySelector('#clear-search');
    const clearSearchButton = context.querySelector('#clear-search-2');
    const addressCheckButton = context.querySelector('#check-address');
    AppState.set('addressConfirmed', addressConfirmed);
    // User clicks 'Clear' text within the input.
    clearSearch.onclick = () => clearSelections(addressResults, addressField, clearSearch, addressConfirmation, buttonGroupConfirm);
    // User clicks the 'Clear' button after making a selection.
    clearSearchButton.onclick = (event) => {
        event.preventDefault();
        clearSelections(addressResults, addressField, clearSearch, addressConfirmation, buttonGroupConfirm);
    };
    // User clicks the 'Check address' button after making a selection.
    addressCheckButton.onclick = (event) => __awaiter(void 0, void 0, void 0, function* () { return getAddressServiceQualification(event); });
    // Clear out address field on cmd/ctr+backspace.
    const { key, ctrlKey, metaKey } = event;
    if ((key === 'Backspace' && ctrlKey && !metaKey) ||
        (key === 'Backspace' && !ctrlKey && metaKey)) {
        clearSelections(addressResults, addressField, clearSearch, addressConfirmation, buttonGroupConfirm);
        addressResults.classList.remove('active');
    }
    // Submit address string to endpoint on each keystroke.
    if (addressField.value) {
        const encodedAddressInput = encodeURIComponent(addressField.value);
        fetch(addressEndpoint + encodedAddressInput, {
            headers: {
                'client_id': onePlatformApiClientId,
                'client_secret': onePlatformApiClientSecret
            }
        })
            .then(response => {
            if (!response.ok) {
                throw new Error('There was an error retrieving the address.');
            }
            // Retrieve addresses based on user keystrokes.
            return response.json();
        })
            .then((data) => {
            // Replace any previous address results with new ones (max four).
            removeResultItems(addressResults);
            let throttleAddresses = data.compositeAddress.slice(0, 4);
            // Build address search result <li> elements for selection.
            throttleAddresses.forEach((address) => {
                const { composite, gnafId } = address;
                let newLi = document.createElement('li');
                newLi.innerText = composite;
                newLi.setAttribute('id', gnafId);
                newLi.classList.add('search-result', 'p-3');
                /* Add the address string for display and GNAFId as
                data-address-id attribute for the clicked address. */
                newLi.onclick = (event) => {
                    addressResults.style.display = 'none';
                    buttonGroupConfirm.style.display = 'flex';
                    addressConfirmation.style.display = 'block';
                    const targetElement = event.target;
                    addressConfirmed.innerText = targetElement.innerText;
                    addressConfirmed.setAttribute('data-address-id', targetElement.id);
                };
                addressResults.appendChild(newLi);
            });
        })
            .catch(error => console.log(error));
        clearSearch.style.display = 'block';
        addressResults.classList.add('active');
    }
    else {
        // If user backspaces until empty field.
        removeResultItems(addressResults);
        addressResults.classList.remove('active');
    }
};
